import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { CookiesProvider } from 'react-cookie';
import reportWebVitals from './reportWebVitals';
import { createRoot } from 'react-dom/client';
import TagManager from 'react-gtm-module';
import App from './App';


// GTM 초기화 추가
const GTM_ID = 'GTM-WCP7783L'; // 실제 컨테이너 ID로 변경

// 앱 로드 시 GTM 한 번만 초기화
TagManager.initialize({
    gtmId: GTM_ID,
    // 필요 시 초기 dataLayer 설정
    // dataLayer: {
    //   appType: 'hybrid_webview',
    // },
});

const root = createRoot(document.getElementById('root'));
root.render(
    <CookiesProvider>
        <BrowserRouter>
            <App />
        </BrowserRouter>
    </CookiesProvider>
);

reportWebVitals();
